import React from "react";
import { Box, Logo, Typography } from "@bca/ui-library";

const LogoSection = () => (
  <Box display="flex" aria-label="BCA logo container" marginY="0px">
    <Logo m={1}></Logo>
  </Box>
);

const BCA = () => (
  <Box
    marginTop="52px"
    paddingX="48px"
    paddingY="32px"
    display="flex"
    flexDirection="column"
    backgroundColor="rgba(246, 246, 246, 0.5)"
  >
    <LogoSection />
    <Typography variant="h6" marginY="0px" color="primary-navy-blue">
      British Car Auctions Limited
    </Typography>
    <Typography marginY="4px" variant="label">
      Headway House, Crosby Way, Farnham, Surrey GU9 7XG{" "}
      <strong>www.bca.co.uk</strong>
    </Typography>

    <Typography marginY="0px" variant="label">
      <strong>Registered in England</strong> No. 00438886{" "}
      <strong>V.A.T Registration No. </strong>
      GB 188 1552 38
    </Typography>
  </Box>
);

export default BCA;
